<template>
    <div class="form-type-0">
        <form @submit.prevent="createAudience" @input="onInputChange" ref="form" novalidate>
            <CustomInput
                v-model="name"
                inputKey="audience_name"
                ref="name"
                pattern="^[a-zA-Z0-9 _-]+$"
                required
            />
            <button type="submit" :disabled="loading">
                <span v-if="loading" class="loading-spinner-type-1"></span>
                <span v-else>{{ $t('forms.create_audience.button') }}</span>
            </button>
            <p v-if="formError" class="form-error">{{ $t('forms.create_audience.error') }}</p>
        </form>
    </div>
</template>

<script>
    import { useAccountStore } from '@/stores/account';
    import { useAudienceStore } from '@/stores/audience';
    import { useCompaniesStore } from '@/stores/companies';
    import formMixin from '@/mixins/formMixin';
    import CustomInput from '@/components/elements/inputs/CustomInput';

    export default {
        mixins: [formMixin],
        emits: ['form_submission_successful'],
        components: {
            CustomInput
        },
        data() {
            return {
                name: ''
            };
        },
        computed: {
            accountStore() {
                return useAccountStore();
            },
            audienceStore() {
                return useAudienceStore();
            },
            companiesStore() {
                return useCompaniesStore();
            },
        },
        methods: {
            async createAudience() {
                const form = this.$refs.form;
                if(form.checkValidity()) {
                    this.loading = true;
                    let newAudience = {
                        name: this.name,
                        company_options: JSON.stringify(this.companiesStore.options),
                        qid: this.companiesStore.qid
                    };
                    const success = await this.audienceStore.createAudience(newAudience);
                    this.loading = false;
                    
                    if (success) {
                        form.reset();
                        this.formError = false;
                        this.$emit('form_submission_successful');
                    } else {
                        this.formError = true;
                    }
                } else {
                    this.validateAllFields();
                }
            }
        }
    }
</script>